export enum CompanyDataCollectionReportCategory {
  None = 0,
  CorporateGovernance = 1,
  Compensation = 2,
  Audit = 3,
  Csr = 4,
  VotingResults = 5
}
